import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

/* COMMON */
import Navbar from "./component/Navbar/Navbar";
import Footer from "./component/Footer/Footer.js";
import TermsConditions from "./component/Footer/TermsConditions/TermsConditions";
import PrivacyPolicy from "./component/Footer/PrivacyPolicy/PrivacyPolicy";
import HelpSupport from "./component/Profile/HelpSupport/HelpSupport";
import AboutUs from "./component/Footer/AboutUs/AboutUs.js";
import Services from "./component/Footer/Services/Services.js";
import AllPackages from './component/HomePage/CategorySection/AllPackages';
/* LOCATION */
import LocationPopup from "./LocationPopup";

/* CONTEXT */
import { CartProvider } from "./context/CartContext";
import { SlotProvider } from "./context/SlotContext";
import { LocationProvider } from "./context/LocationContext";

/* UI */
import LoginPopup from "./component/common/LoginPopup";
import GlobalLoginHandler from "./component/common/GlobalLoginHandler";
import NotificationHandler from "./component/common/NotificationHandler";

/* HOME */
import ViewAllCategories from "./component/HomePage/CategorySection/ViewAllCategories";
import AllFilter from "./component/HomePage/Allfillter";
import AllCategories from "./component/AllCategories";
import CarePlanPage from "./component/CarePlanPage";
import SpecializedBanner from "./component/HomePage/BannerDetails/SpecializedBanner";
import TrendingTodayDetails from "./component/HomePage/BannerDetails/TrendingTodayDetails";
import OfferForYouDetails from "./component/HomePage/BannerDetails/OfferForYouDetails";

/* AUTH */
import SignIn from "./component/Signin/SignIn";
import PartnerWithUs from "./component/HomePage/Partner/PartnerWithUs";

/* PROFILE */
import Profile from "./component/Profile/Profile";
import FamilyMemberById from "./component/Profile/FamilyMember/FamilyMemberById";
import Address from "./component/Profile/Address/Index";

/* CART */
import CartPage from "./component/Cart/CartPage";
import ReplaceCartPopup from "./component/Cart/Popup.js";
import CartDrawer from "./component/Cart/CartPage.js";
import AllTests from "./component/HomePage/CategorySection/AllTests";

/* LAB */
import LabTest from "./component/LabTest/Page";
import LabList from "./component/LabTest/LabList";
import LabDetails from "./component/LabTest/LabDetails";
import TestDetail from "./component/LabTest/TestDetail";
import TestDetails from "./component/LabTest/TestDetails";
import SymptomsDetails from "./component/LabTest/SymptomsDetails";
import GetPackageDetails from "./component/LabTest/GetPackageDetails"; // ✅ ADDED

/* MEDICINE */
import Medicine from "./component/Medicine/MedicinePage";
import GetMedicineByStore from "./component/Medicine/GetMedicineByStore";
import MedicineDetails from "./component/Medicine/MedicineDetails";

/* OTHER */
import Beauty from "./component/Beauty/BeautyPage";
import Wellness from "./component/Wellness";
import BrandDetails from "./component/HomePage/BrandDetails";

import Crud from "./component/Crud";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/* ================= REDUX FIX ADDED ================= */
import { useSelector, useDispatch } from "react-redux";
import { closeCartSlider } from "./Redux/cartSliderSlice";

export default function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showCart, setShowCart] = useState(false);

  /* ================= REDUX CART CONTROL ================= */
  const isCartOpen = useSelector(
    (state) => state.cartSlider?.isOpen
  );

  // ================= HIDE NAVBAR =================
  const hideNavbarRoutes = ["/signin", "/crud"];

  const hideNavbar = hideNavbarRoutes.some((route) =>
    location.pathname.toLowerCase().startsWith(route)
  );

  // ================= HIDE LOGIN POPUP =================
  const hideLoginPopupRoutes = ["/signin"];

  const hideLoginPopup = hideLoginPopupRoutes.some((route) =>
    location.pathname.toLowerCase().startsWith(route)
  );

  // ================= SPACING CONTROL =================
  const noSpacingRoutes = ["/terms-conditions", "/privacy-policy"];

  const removeSpacing = noSpacingRoutes.some((route) =>
    location.pathname.toLowerCase().startsWith(route)
  );

  // ================= CLOSE CART ON ROUTE CHANGE =================
  useEffect(() => {
    setShowCart(false);
    dispatch(closeCartSlider());
  }, [location.pathname, dispatch]);

  return (
    <LocationProvider>
      <CartProvider>
        <SlotProvider>

          <NotificationHandler />
          <LocationPopup />

          {/* NAVBAR */}
          {!hideNavbar && (
            <Navbar
              onCartClick={() => navigate("/cart")}
            />
          )}

          {/* SPACING */}
          {!hideNavbar && !removeSpacing && (
            <div className="pt-[100px] md:pt-[110px]" />
          )}

          {/* LOGIN HANDLER */}
          {!hideLoginPopup && (
            <GlobalLoginHandler
              onTrigger={() => {
                const token = localStorage.getItem("token");
                const user = localStorage.getItem("user");

                if (!token && !user) {
                  setShowLoginPopup(true);
                }
              }}
            />
          )}

          {/* MAIN ROUTES */}
          <div className="min-h-screen bg-gray-50 overflow-x-hidden">
            <Routes>

              <Route path="/" element={<AllFilter />} />
              <Route path="/allcategories" element={<AllCategories />} />
              <Route path="/all" element={<ViewAllCategories />} />
              <Route path="/care-plan" element={<CarePlanPage />} />
              <Route path="/all-tests" element={<AllTests />} />
              <Route path="/all-packages" element={<AllPackages />} />
              <Route path="/brand/:id" element={<SpecializedBanner />} />
              <Route path="/trending-today/:id" element={<TrendingTodayDetails />} />
              <Route path="/offerforyou-details/:labId" element={<OfferForYouDetails />} />

              <Route path="/signin" element={<SignIn />} />
              <Route path="/partner-with-us" element={<PartnerWithUs />} />

              <Route path="/profile" element={<Profile />} />
              <Route path="/family-member/:userId" element={<FamilyMemberById />} />
              <Route path="/address" element={<Address />} />

              <Route path="/cart" element={<CartPage />} />

              <Route path="/lab" element={<LabList />} />
              <Route path="/lab/:id" element={<LabDetails />} />
              <Route path="/labtest" element={<LabTest />} />
              <Route path="/lablist" element={<LabList />} />
              <Route path="/labdetails/:id" element={<LabDetails />} />
              <Route path="/TestDetail/:id" element={<TestDetail />} />
              <Route path="/TestDetails/:id" element={<TestDetails />} />
              <Route path="/SymptomsDetails/:symptomId" element={<SymptomsDetails />} />

              <Route path="/medicine" element={<Medicine />} />
              <Route path="/get-medicine-by-store/:companyId" element={<GetMedicineByStore />} />
              <Route path="/medicinedetails/:id" element={<MedicineDetails />} />

              <Route path="/beauty" element={<Beauty />} />
              <Route path="/wellness" element={<Wellness />} />
              <Route path="/brand-details/:brandId" element={<BrandDetails />} />
             

              <Route path="/crud" element={<Crud />} />

              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/faq" element={<HelpSupport />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/services" element={<Services />} />

            </Routes>

            <ToastContainer
              position="top-right"
              autoClose={1000}
              hideProgressBar
              newestOnTop
              closeOnClick
              pauseOnHover={false}
              draggable={false}
              theme="colored"
              style={{ zIndex: 999999999 }}
            />
          </div>

          {/* ================= CART FIX ================= */}
          {isCartOpen && (
            <CartDrawer
              onClose={() => dispatch(closeCartSlider())}
            />
          )}

          <ReplaceCartPopup />

          {/* FOOTER */}
          {!hideNavbar && <Footer />}

          {/* LOGIN POPUP */}
          {!hideLoginPopup && (
            <LoginPopup
              isOpen={showLoginPopup}
              onClose={() => setShowLoginPopup(false)}
            />
          )}

        </SlotProvider>
      </CartProvider>
    </LocationProvider>
  );
}